import React from 'react'
import { Accordion, Col, Row } from 'react-bootstrap'
import { SelectOption } from '../../../../../../../components/SelectDropdown/SelectDropdown'
import { ObjectTypeDropdown } from './ObjectTypeDropdown'
import { ObjectRowActionsMenu, ObjectRowActionsMenuItem } from './ObjectRowActionsMenu'
import './ObjectRowShell.scss'

export interface ObjectRowShellProps {
  index: number
  activeKey: string | null
  onAccordionSelect: (eventKey: string | null | undefined) => void
  options: SelectOption[]
  excludeObjectNames?: Set<string>
  selectedObjectName?: string
  onOptionSelected: (option: SelectOption) => void
  loading?: boolean
  disabled?: boolean
  disabledTitle?: string
  menuItems: ObjectRowActionsMenuItem[]
  headerExtra?: React.ReactNode
  body: React.ReactNode | null
}

export const ObjectRowShell: React.FC<ObjectRowShellProps> = ({
  index,
  activeKey,
  onAccordionSelect,
  options,
  excludeObjectNames,
  selectedObjectName,
  onOptionSelected,
  loading,
  disabled,
  disabledTitle,
  menuItems,
  headerExtra,
  body,
}) => (
  <Row>
    <Col className='p-0'>
      <Accordion className='object-row-accordion' activeKey={activeKey} onSelect={(k) => onAccordionSelect(k as string | null)}>
        <Accordion.Item eventKey={String(index)}>
          <Accordion.Header>
            <div className='flex-grow-1 me-3'>
              <ObjectTypeDropdown
                options={options}
                excludeObjectNames={excludeObjectNames}
                selectedObjectName={selectedObjectName}
                onOptionSelected={onOptionSelected}
                loading={loading}
                disabled={disabled}
                disabledTitle={disabledTitle}
              />
            </div>

            <ObjectRowActionsMenu items={menuItems} />

            {headerExtra}
          </Accordion.Header>
          {body !== null && <Accordion.Body>{body}</Accordion.Body>}
        </Accordion.Item>
      </Accordion>
    </Col>
  </Row>
)
